import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ViewLoading from 'components/view/loading';
import DomainsPage from 'components/storefront/domains';
import actions from 'actions';

const mapStateToProps = (state) => ({
  domains: state.storefronts.domains,
  loading: state.storefronts.loading,
});

const mapDispatchToProps = (dispatch) => ({
  fetchDomains: () => {
    return dispatch(actions.storefronts.fetchDomains());
  },

  updateStorefront: (id, data) => {
    return dispatch(actions.storefronts.update(id, data));
  },

  createDomain: (data) => {
    return dispatch(actions.storefronts.createDomain(data));
  },

  updateDomain: (id, data) => {
    return dispatch(actions.storefronts.updateDomain(id, data));
  },

  verifyDomain: (id) => {
    return dispatch(actions.storefronts.verifyDomain(id));
  },

  deleteDomain: (id) => {
    return dispatch(actions.storefronts.deleteDomain(id));
  },

  fetchEntriToken: () => {
    return dispatch(actions.storefronts.fetchEntriToken());
  },
});

export class StorefrontDomains extends React.PureComponent {
  static contextTypes = {
    notifyError: PropTypes.func.isRequired,
    notifySuccess: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      loaded: false,
      verifying: false,
      fetchDomains: this.fetchDomains.bind(this),
      onCreateDomain: this.onCreateDomain.bind(this),
      onVerifyDomain: this.onVerifyDomain.bind(this),
      onUpdateDomain: this.onUpdateDomain.bind(this),
      onDeleteDomain: this.onDeleteDomain.bind(this),
    };
  }

  mounted = false;
  verifyingTimer = null;

  async componentWillMount() {
    this.mounted = true;

    await this.fetchDomains();

    this.setState({
      loaded: true,
    });
  }

  componentWillUnmount() {
    this.mounted = false;

    if (this.watchVerifying) {
      clearTimeout(this.verifyingTimer);
    }
  }

  async fetchDomains() {
    const { fetchDomains } = this.props;

    if (!this.mounted) {
      return;
    }

    const domains = await fetchDomains();

    this.watchVerifying(domains);
  }

  watchVerifying(domains) {
    console.log('watchVerifying', domains);
    const { results } = domains;

    const verifyingDomains = results.filter((domain) => domain.verifying);

    if (verifyingDomains.length > 0 && !this.verifyingTimer) {
      this.verifyingTimer = setTimeout(() => {
        this.verifyingTimer = null;
        this.fetchDomains();
      }, 30000);
    } else if (verifyingDomains.length === 0 && this.verifyingTimer) {
      clearTimeout(this.verifyingTimer);
      this.verifyingTimer = null;
    }
  }

  async onCreateDomain(values) {
    const { createDomain } = this.props;
    const { notifyError } = this.context;

    const result = await createDomain(values);

    if (!result) {
      return false;
    } else if (result.errors) {
      notifyError(result.errors);
      return false;
    }

    this.fetchDomains();

    return result;
  }

  async onDeleteDomain(id) {
    const { deleteDomain } = this.props;
    const { notifyError } = this.context;

    const result = await deleteDomain(id);

    if (!result) {
      return false;
    } else if (result.errors) {
      notifyError(result.errors);
      return false;
    }

    this.fetchDomains();

    return result;
  }

  async onVerifyDomain(id) {
    const { verifyDomain } = this.props;
    const { notifyError } = this.context;

    const result = await verifyDomain(id);

    if (!result) {
      return false;
    } else if (result.errors) {
      notifyError(result.errors);
      return false;
    }

    this.fetchDomains();

    return result;
  }

  async onUpdateDomain(id, values) {
    const { updateDomain } = this.props;
    const { notifyError } = this.context;

    const result = await updateDomain(id, values);

    if (!result) {
      return false;
    } else if (result.errors) {
      notifyError(result.errors);
      return false;
    }

    this.fetchDomains();

    return result;
  }

  render() {
    if (!this.state.loaded) {
      return <ViewLoading />;
    }

    return <DomainsPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(StorefrontDomains);
